import React from "react";
import VideoBlogLayout from "../../components/VideoBlogLayout";

const BlogAlishaEobPosting = () => (
  <VideoBlogLayout
    category="Video Demo"
    eyebrow="AI-Powered EOB Posting"
    title="Let me guess: your staff spent more than 15 hours this week posting EOBs"
    subtitle="Watch Alisha post a batch — and catch the downcodes, alternative benefits, and fee mismatches your team misses when they're moving fast."
    author="Asha Team"
    date="May 23, 2026"
    readTime="5 min watch"
    videoUrl="https://www.loom.com/embed/3ef872e7cfd7428aaaab0e573b956779"
    videoTitle="How Asha AI Automatically Posts Your EOBs"
    videoProvider="loom"
  >
    <div className="space-y-14">
      <div>
        <p className="text-lg text-gray-600 leading-relaxed mb-4">
          Payment posting is repetitive, detail-heavy work. And while everyone's
          moving fast, downcoded procedures and mismatched fee schedules can
          slip through and quietly become revenue leakage.
        </p>
        <p className="text-lg text-gray-600 leading-relaxed">
          Asha's AI EOB Posting Agent — we call her{" "}
          <strong className="text-gray-900 font-semibold">Alisha</strong> —
          automates the posting workflow and checks payments against contracted
          fee schedules and ledger balances in parallel. Speed is one win.
          Catching what teams miss when busy is the bigger one.
        </p>
      </div>

      <div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 tracking-tight">
          What Alisha catches
        </h2>
        <ul className="space-y-3 text-lg text-gray-600 leading-relaxed">
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>Reads electronic 835s and scanned paper EOBs — same workflow.</span>
          </li>
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Posts payments and reconciles balances faster than manual
              line-by-line entry, with checks at the line-item level.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Verifies against contracted fee schedules and ledger balance in
              parallel — not just posting what the payer sends.
            </span>
          </li>
          <li className="flex gap-3">
            <span className="text-blue-600 mt-1.5 flex-shrink-0">•</span>
            <span>
              Flags downcodes, alternative benefits, and fee mismatches
              immediately — before they're buried in the system.
            </span>
          </li>
        </ul>
      </div>

      <div className="rounded-2xl border border-blue-100 bg-blue-50/60 p-6">
        <h3 className="text-lg font-bold text-blue-900 mb-2">
          Verified at the contracted rate, automatically
        </h3>
        <p className="text-base text-gray-700 leading-relaxed">
          All checks run in the background. Discrepancies surface immediately
          so your team doesn't have to hunt for missed revenue weeks later.
        </p>
      </div>

      <div>
        <p className="text-lg text-gray-600 leading-relaxed">
          Faster posting, accurate balances, and underpayments that don't slip
          through unnoticed.
        </p>
      </div>
    </div>
  </VideoBlogLayout>
);

export default BlogAlishaEobPosting;
